import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DiscrepancySearchField from "@tKgpco/Widgets/DiscrepancyHistory/DiscrepancySearchField";
import RMASearchField from "@tKgpco/Widgets/RMAHistory/RMASearchField";
import * as React from "react";

export const discrepancyIdStyles: SearchTextFieldStyles = {};
const styles = discrepancyIdStyles;

const RMASearchFieldNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <RMASearchField
            styles={styles}
            parameterField="rmaNumber"
            label="RMA #"
            inputType="text"
            placeholder=""
            testSelector="rma_filterRmaNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: RMASearchFieldNumber,
    definition: {
        group: "Common",
        displayName: "RMA Id Search",
    },
};

export default widgetModule;
